/** @format */

import {styled} from '@mui/material/styles';
import {Button} from '@mui/material';

interface RootProps {
  customColor: string;
}

export const Root = styled(Button, {
  shouldForwardProp: prop => prop !== 'customColor',
})<RootProps>(({theme, customColor}) => ({
  border: `1px solid ${customColor}33`,
  color: theme.palette.semantic_dark?.surface.onSurface,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',

  '&.Mui-disabled': {
    color: theme.palette.semantic_dark?.surface.onSurface,
  },
}));
